import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { getTranslation } from "../heplers/translationHelper";

const formatEuro = (number) => {
  if (number === null || number === 0 || number === undefined || isNaN(number)) return '';
  return new Intl.NumberFormat('de-DE').format(number);
};

const parseEuroString = (str) => {
  if (!str) return null;
  const cleaned = str.replace(/\./g, '').replace(',', '.').replace(/\s/g, '');
  const parsed = parseFloat(cleaned);
  return isNaN(parsed) ? null : parsed;
};
  const format=(number)=>{
    if(number)
    return number
    .replace(/[. ]/g, '') // Remove thousands separators
    .replace(',', '.');
    return "0,00"
  }
const EuroTextField = ({
  value,
  onChange,
  name,
  label,
  error,
  helperText,
  ...rest
}) => {
  const [displayValue, setDisplayValue] = useState("");
  const [displayError, setDisplayError] = useState(false);
  

  // Update display when external value changes (e.g., reset or load)
  useEffect(() => {
    if(value){
    // Step 1: replace "." with a placeholder
let temp = value.toString().replace(/\./g, "#");

// Step 2: replace "," with "."
temp = temp.replace(/,/g, ".");

// Step 3: replace placeholder with ","
let result = temp.replace(/#/g, ",");
// Split integer and decimal parts
let [integerPart, decimalPart] = result.split(",");

// Add dot as thousands separator
integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

// Recombine with decimal part
let formatted = decimalPart ? `${integerPart},${decimalPart}` : integerPart;

    setDisplayValue(formatted);
  }
  }, []);



const handleChange = (e) => {
  if (/^[0-9.,]*$/.test(e.target.value)) {
  parseEuropeanNumber(e.target.value)
  }else{
  alert("boom")
    return;
  }
  // let inputValue = e.target.value;

  // // Replace ',' with '.' and '.' with ','
  // if (inputValue.includes(',') || inputValue.includes('.')) {
  //   inputValue = inputValue
  //     .split('')
  //     .map((char) => {
  //       if (char === ',') return '.';
  //       if (char === '.') return ',';
  //       return char;
  //     })
  //     .join('');
  // }

  // // Allow only digits, dot, comma, space
  // if (/^[\d.,\s]*$/.test(inputValue)) {
  //   setDisplayValue(inputValue);

  //   const parsed = parseEuroString(inputValue);
  //   if (onChange) {
  //     onChange({
  //       target: {
  //         name,
  //         value: parsed,
  //       },
  //     });
  //   }
  // }
};

function parseEuropeanNumber(europeanNumber) {
let commaCount = europeanNumber.split(",").length - 1;
  if(commaCount>1){
  setDisplayError(true)
return;
}
else
  setDisplayError(false)
  // Remove thousands separators (periods and spaces)
  // Replace comma with period for decimal separator
// Step 1: replace "." with a placeholder
let temp = europeanNumber.replace(/\./g, "#");

// Step 2: replace "," with "."
temp = temp.replace(/,/g, ".");

// Step 3: replace placeholder with ","

  const standardFormat = temp.replace(/#/g, ",");
      if (onChange) {
  console.log("kjashdkljahdalkjd",standardFormat)

      onChange({
        target: {
          name,
          value: standardFormat.replace(",",''),
        },
      });
    }
  // return parseFloat(standardFormat);

  setDisplayValue(europeanNumber)
}


  return (
    <TextField
      variant="outlined"
      required
      fullWidth
      size="small"
      id={name}
      name={name}
      label={label}
      value={displayValue}
      onChange={handleChange}
      error={error || displayError}
      helperText={(error && helperText)||(displayError && getTranslation("Invalid Format"))}
      // InputProps={{ inputProps: { min: 0 } }}
      placeholder='0,00'
      // {...rest}
    />
  );
};



export default EuroTextField;
